/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransferPartnerSummary } from './TransferPartnerSummary';
import {
    TransferPartnerSummaryFromJSON,
    TransferPartnerSummaryFromJSONTyped,
    TransferPartnerSummaryToJSON,
    TransferPartnerSummaryToJSONTyped,
} from './TransferPartnerSummary';

/**
 * First event emitted by `GET /v3/additional_rates/{hotel_id}/stream`.
 * Tells the client which rate sources to expect terminal results from
 * so it can render a deterministic progress indicator, and ships the
 * transfer-partner summaries up front (they depend only on user +
 * property, not on rate results, so the client can render the
 * transfer-partner block before any rate arrives).
 * 
 * @export
 * @interface HotelRateStreamSessionStart
 */
export interface HotelRateStreamSessionStart {
    /**
     * 
     * @type {string}
     * @memberof HotelRateStreamSessionStart
     */
    type: HotelRateStreamSessionStartTypeEnum;
    /**
     * Deterministic SHA1 hex of the natural-key tuple
     * `(user_id, vpid, checkin, checkout, occupancy, loyalty_account_id, canonical_rate_sources)`.
     * Matches `HotelRateSession.id` for the substrate row backing
     * this stream.
     * 
     * @type {string}
     * @memberof HotelRateStreamSessionStart
     */
    sessionId: string;
    /**
     * Rate sources the impl will attempt for this property/user.
     * Possible values: `travelport`, `direct`, `liteapi`. The stream
     * yields one `rates` event per source whose terminal status
     * arrives.
     * 
     * @type {Array<string>}
     * @memberof HotelRateStreamSessionStart
     */
    sourcesExpected: Array<HotelRateStreamSessionStartSourcesExpectedEnum>;
    /**
     * Computed at session_start time because the underlying summarizer
     * only takes (user_id, property_content) — no rate dependency.
     * 
     * @type {Array<TransferPartnerSummary>}
     * @memberof HotelRateStreamSessionStart
     */
    transferPartnerSummaries?: Array<TransferPartnerSummary>;
}


/**
 * @export
 */
export const HotelRateStreamSessionStartTypeEnum = {
    SessionStart: 'session_start'
} as const;
export type HotelRateStreamSessionStartTypeEnum = typeof HotelRateStreamSessionStartTypeEnum[keyof typeof HotelRateStreamSessionStartTypeEnum];

/**
 * @export
 */
export const HotelRateStreamSessionStartSourcesExpectedEnum = {
    Travelport: 'travelport',
    Direct: 'direct',
    Liteapi: 'liteapi'
} as const;
export type HotelRateStreamSessionStartSourcesExpectedEnum = typeof HotelRateStreamSessionStartSourcesExpectedEnum[keyof typeof HotelRateStreamSessionStartSourcesExpectedEnum];


/**
 * Check if a given object implements the HotelRateStreamSessionStart interface.
 */
export function instanceOfHotelRateStreamSessionStart(value: object): value is HotelRateStreamSessionStart {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('sourcesExpected' in value) || value['sourcesExpected'] === undefined) return false;
    return true;
}

export function HotelRateStreamSessionStartFromJSON(json: any): HotelRateStreamSessionStart {
    return HotelRateStreamSessionStartFromJSONTyped(json, false);
}

export function HotelRateStreamSessionStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateStreamSessionStart {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'sessionId': json['session_id'],
        'sourcesExpected': json['sources_expected'],
        'transferPartnerSummaries': json['transfer_partner_summaries'] == null ? undefined : ((json['transfer_partner_summaries'] as Array<any>).map(TransferPartnerSummaryFromJSON)),
    };
}

export function HotelRateStreamSessionStartToJSON(json: any): HotelRateStreamSessionStart {
    return HotelRateStreamSessionStartToJSONTyped(json, false);
}

export function HotelRateStreamSessionStartToJSONTyped(value?: HotelRateStreamSessionStart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'session_id': value['sessionId'],
        'sources_expected': value['sourcesExpected'],
        'transfer_partner_summaries': value['transferPartnerSummaries'] == null ? undefined : ((value['transferPartnerSummaries'] as Array<any>).map(TransferPartnerSummaryToJSON)),
    };
}

